// extracted by mini-css-extract-plugin
export default {"priority-box":"Priority_priority-box__wInsk","priority-box-important":"Priority_priority-box-important__ZC8wm","priority-box-urgent":"Priority_priority-box-urgent__-9FJV"};